// This icon file is generated automatically.
var PTrophyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.56 1.5h-1.44V.87A.13.13 0 0011 .76H3a.13.13 0 00-.13.13v.62H1.45c-.38 0-.69.3-.69.69V4.5c0 1.28.94 2.34 2.16 2.53a4 4 0 003.53 3.45v1.64H3.37a.5.5 0 00-.5.5v.5c0 .07.06.13.13.13h8c.07 0 .13-.06.13-.13v-.5a.5.5 0 00-.5-.5H7.55v-1.64a4 4 0 003.53-3.45 2.57 2.57 0 002.16-2.53V2.19c0-.38-.3-.69-.69-.69zm-10.69 3V2.62h1v3.25c-.57-.19-1-.73-1-1.37zm8.13 2a2.85 2.85 0 01-2.88 2.88h-.25A2.85 2.85 0 014 6.5V1.87h6V6.5zm2.13-2c0 .64-.43 1.18-1 1.37V2.62h1V4.5z", "fill-rule": "nonzero" } }] }, "name": "p-trophy", "theme": "outlined" };
export default PTrophyOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTrophyOutlined.js
// module id = 3692
// module chunks = 0